module.exports = __webpack_public_path__ + "static/media/american-express.a7a51314.svg";